export const getAcademicYearOptions = (currentAcademicYear) => {
    const baseYear = currentAcademicYear || (new Date().getMonth() >= 8 ? new Date().getFullYear() : new Date().getFullYear() - 1);
    const years = [];
    for (let i = -2; i <= 2; i++) {
      const year = baseYear + i;
      years.push(year);
    }
    return years;
  };